module.exports = __webpack_public_path__ + "static/media/claim.5e35446d.svg";